import { FC, useState } from 'react'
import { Theme, InputBase, Paper, InputBaseProps } from '@mui/material'
import { styled } from '@mui/material/styles'
import { Icon } from 'packages/eid-icons'
import { IconButton } from 'packages/eid-ui'
import { mobileScreenWidth } from 'utils'

const StyledPaper = styled(Paper, {
    shouldForwardProp: (prop) => prop !== 'error',
})<{ error?: boolean }>(({ theme, error }) => ({
    padding: '0.2rem 0.4rem',
    display: 'flex',
    alignItems: 'center',
    width: 400,
    fontSize: '1.8rem',
    border: error ? 'solid 1px red' : 'solid 1px #d8d8dd',
    [`@media (max-width:${mobileScreenWidth})`]: {
        width: 'auto',
    },
}))

const StyledInputBase = styled(InputBase)(({ theme }) => ({
    marginLeft: theme.spacing(1),
    flex: 1,
    fontSize: '2rem',
    color: '#8b909a',
    width: '100%',
    '& input::placeholder': {
        fontSize: '1.8rem',
    },
}))

const StyledIconButton = styled(IconButton)({
    padding: 10,
})

const IconButtonText = styled('p')({
    margin: 0,
    padding: 0,
    color: '#bdbdbd',
    fontSize: '1rem',
    marginBottom: '-0.4rem',
})

export interface PasswordInputProps extends InputBaseProps {}

export const PasswordInput: FC<PasswordInputProps> = (props) => {
    const { error, ...rest } = props

    const [showPassword, setShow]: any = useState(false)

    return (
        <StyledPaper error={error}>
            <StyledIconButton size="large">
                <Icon
                    style={{ cursor: 'default' }}
                    name="Lock"
                    color="#D2D2D2"
                />
            </StyledIconButton>
            <form
                name="masterPasswordInputForm"
                style={{ width: '100%' }}
                onSubmit={(e) => e.preventDefault()}
            >
                <StyledInputBase
                    placeholder="Master Password"
                    type={showPassword ? 'text' : 'password'}
                    {...rest}
                />
            </form>
            <StyledIconButton
                onClick={() => setShow((prev: any) => !prev)}
                size="large"
            >
                <div>
                    <IconButtonText>
                        {showPassword ? 'Hide' : 'Show'}
                    </IconButtonText>
                    <Icon name="View" color="#d2d2d2" />
                </div>
            </StyledIconButton>
        </StyledPaper>
    )
}
